<template>
  <div class="col-sm-9 mx-auto maincontainer">
    <div v-show="!showInvoice">
      <div v-if="!newsLoaded"></div>
      <div else>
        <b-modal
            ref="info-modal"
            id="info-modal"
            :title="getModalTitle"
            ok-only
        >
          <span class="my-4" v-html="getModalDescription"></span>
        </b-modal>
      </div>

      <b-modal
          ref="unknownUser-modal"
          id="unknownUser-modal"
          title="User not found/authorized"
          @ok="sendToLegacy"
          @hidden="sendToLegacy"
          @close="sendToLegacy"
          @cancel="sendToLegacy"
          ok-only
      >
        <p>
          Your account is not authorized to access MY LINK, press OK to be redirected
          to the Link homepage.
        </p>
        <p>If you require access to MY LINK please contact your local customer service</p>
      </b-modal>

      <b-modal
          ref="branchSelector-modal"
          id="branchSelector-modal"
          title="Select branch"
          @ok="handleReturnShipment"
          ok-only
          no-close-on-esc
          no-close-on-backdrop
          hide-header-close
          centered>
        <p>Select the branch from which the return shipment is sent.</p>
        <b-form-select v-model="selectedBranch"
                       class="mb-3">
          <option v-for="option in this.getVisibleUserBranches" :value="option">{{ option.name }}</option>
        </b-form-select>
      </b-modal>

      <b-row>
        <div class="col-sm-12 headingRow">
          <font-awesome-icon icon="box-open" size="3x" />
          <h3 style="padding-left:10px">{{ $t('menu.shipment.create') }}</h3>
        </div>
      </b-row>
      <div class="row mt-2" id="errors" v-if="getBackendErrors.length > 0">
        <div class="col-sm-6">
          <div
              class="alert alert-danger"
              role="alert"
              name="bookingErrors"
          >
            <ul>
              <li
                  v-for="item in getBackendErrors"
                  v-bind:key="item.message"
              >
                {{ item.localizedMessage }}
                <span
                    v-for="validationError in item.validationErrors"
                    v-bind:key="validationError.message"
                >
                                      <br /> 
                                      {{
                    validationError.prefix === "shipment"
                        ? "Shipment"
                        : $t('createShipment.errors.prefix.' + validationError.prefix)
                  }}:
                                      {{ $t('createShipment.errors.key.' + validationError.key) }}
                                  </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row mt-2" v-if="isShipmentSet && ready">
        <div class="col-sm-4">
          <user-account
              ref="userAccount"
              :shipment="shipment"
              :viewOptions="viewOptions"
              :v="$v"
          />
          <addresses
              :shipment="shipment"
              :viewOptions="viewOptions"
              :v="$v"
          />
        </div>
        <div class="col-sm-8">
          <div class="row mb-2" v-if="showOnBehalfOf">
            <b-col sm="12" >
              <OnBehalfOf
                  :shipment="shipment"
                  :v="$v"/>
            </b-col>
          </div>
          <div class="row mb-2">
            <b-col sm="12">
              <shipmentOptions
                  :shipment="shipment"
                  :viewOptions="viewOptions"
                  :v="$v"
                  :additional-fields="shipmentOptionsAdditionalFields"
              />
            </b-col>
          </div>
          <b-row v-if="showPickup">
            <b-col sm="12">
              <pickup
                  :key="'pickup-' + selectedCompanyAccountId"
                  ref="bookPickup"
                  :defaultValues="defaultValues"
                  :shipment="shipment"
              />
            </b-col>
          </b-row>
          <div class="row">
            <div class="col-sm-12">
              <packageCard
                  :shipment="shipment"
                  :viewOptions="viewOptions"
                  :v="$v"
              />
            </div>
          </div>
          <b-row class="mt-2" v-if="display(fieldNames.REQUIRE_INVOICE) && !registerShipment">
            <b-col sm="12">
              <book-require-invoice :require-invoice="requireCustoms" @show="showInvoicePage($event)" @setFiles="setUploadFiles($event)" :v="$v" />
            </b-col>
          </b-row>
        </div>
      </div>
      <shippingOptions :shipment="shipment" :files="files" :invoice="invoiceData" :invoice-required="requireInvoiceOnBook" :has-validation-errors="validationErrors" :v="$v" v-if="ready" />
    </div>
    <div v-if="invoiceData != null" v-show="showInvoice">
      <create-invoice :shipment="shipment" :cancelInvoice="() => {this.showInvoicePage(false)}" @hide="hideInvoicePage($event)" :create-on-done="false" />
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue';
import userAccount from '../components/user-account';
import onBehalfOf from '../components/OnBehalfOf.vue';
import addresses from '../components/addresses';
import shipmentOptions from '../components/shipment-options';
import packageCard from '../components/packageCard';
import shippingOptions from '../components/shippingOptions';
import vSelect from '../components/vSelect';
import 'vue-select/dist/vue-select.css';
import { EventBus } from '@/services/event-bus.js';
import pickup from '@/components/pickup';
import { ACTIONS, MUTATIONS, CREATE_SHIPMENT_PREFIX, CORE_PREFIX } from '../store/constants';
import store from '../store';
import { mapState, mapGetters } from 'vuex';
import shipmentValidationMixin from '../mixins/shipmentValidationMixin';
import helper from '../helper';
import { EVENTS } from '../store/nameConstants';
import viewOptions from '../mixins/viewOptionsMixin';
import { FIELD_NAMES } from '../store/nameConstants';
import { format, parseISO } from 'date-fns';
import BookRequireInvoice from "@/components/CreateShipment/BookRequireInvoice";
import CreateInvoice from "@/views/CreateInvoice";
import {ToBase64String} from "@/helpers/shipmentHelper";
import OnBehalfOf from "@/components/OnBehalfOf.vue";

export default {
  components: {
    OnBehalfOf,
    BookRequireInvoice,
    BFormCheckbox,
    vSelect,
    addresses,
    userAccount,
    shipmentOptions,
    packageCard,
    shippingOptions,
    pickup,
    CreateInvoice
  },
  mixins: [shipmentValidationMixin, viewOptions],

  async created() {
    this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);
    this.$store.dispatch(
        CORE_PREFIX + ACTIONS.CORE.SET_CUSTOMER_TRANSACTION_ID,
        this.generateGuid()
    );

    EventBus.$on(EVENTS.NEWS_LOADED, () => {
      this.newsLoaded = true;
      this.showModal();
    });
  },
  beforeDestroy() {
    EventBus.$off('resetShipmentEvent');
  },
  async mounted() {
    const isPrototypeEmpty =
        Object.keys(this.$store.state.createShipment.prototype).length === 0;
    if (!this.isSystemInitialized || isPrototypeEmpty) {
      await store.dispatch(
          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_SHIPMENT_PROTOTYPE
      );
    }

    let cloneShipment = this.setCloneShipment();

    EventBus.$on(EVENTS.UNKNOWN_USER, () => {
      this.showUnknownUserModal();
    });
    
    EventBus.$on(EVENTS.USER_LOADED, () => {
      // $cookies.set('segmentation', userData.shipmentSystem);
      this.shipment.accountId = this.$store.state.core.companyAccountId; // brug en getter
    });

    EventBus.$on(EVENTS.SET_DEFAULT_VALUES, (defaultValues) => {
      this.setDefaultValues(defaultValues);
    });

    this.ready = true;
    await this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.INITIALIZE_CREATE_SHIPMENT);

    this.$store.dispatch(
        CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.SET_PROTOTYPE,
        cloneShipment
    );
    this.ready = true;

    this.resetCreateShipment();

    this.addResetComponentListener();

    this.$route
    
    let awb = this.$route.query.AWB;
    if (awb !== undefined) {
      let shipDate = this.$route.query.SHIPDATE;
      this.shipment.shipDate = shipDate;
      this.registerShipment = true;
    }
    if (this.$route.query.id !== undefined || (this.$route.query.linkid !== undefined && this.$route.query.returnShipment === 'true')) {

      var editShipment = null;
      if (this.$route.query.shotFileShipment === 'true') {
        editShipment = await this.$store.dispatch(
            CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.GETSHOTFILESHIPMENTDATA, this.$route.query.id);
      }
      else if (this.$route.query.id !== undefined) {
        editShipment = await this.$store.dispatch(
            CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.GETSHIPMENTDATA, this.$route.query.id);
      }

      if (this.$route.query.linkid !== undefined) {
        editShipment = await this.$store.dispatch(
            CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.GETSHIPMENTDATABYLINKID, this.$route.query.linkid);
      }

      if (this.$route.query.shotFileShipment === 'true'){
        //Do nothing
      }
      else {
        const shipDate = this.shipment.shipDate;
        editShipment.shipDate = shipDate;
      }

      if (!editShipment.shipmentOptions) {
        editShipment.shipmentOptions = { notStackablePallet: false, incoterms: 'DAP',exportReason: 'Permanent' };
      }


      editShipment.saveFlags = {
        saveDescription: false,
        saveReceiverAddress: false,
        saveSenderAddress: false,
        savePickupAddress: false,
        saveSoldToAddress: false,
        saveBrokerAddress: false,
      };
      await this.$store.dispatch(
          CORE_PREFIX + ACTIONS.CORE.CHANGE_COMPANY,
          editShipment.companyId
      );
      await this.$store.dispatch(
          CORE_PREFIX + ACTIONS.CORE.SET_ACCOUNT,
          editShipment.accountId
      );
      if (editShipment.shipmentType == 'Import') {
        this.$refs['userAccount'].setImport();
      } else if (editShipment.shipmentType == 'Cross') {
        this.$refs['userAccount'].setCross();
      }

      await this.$store.dispatch(
          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_BOOKING_OPTIONS
      );

      this.shipment = editShipment;

      await this.$nextTick();

      if (!this.shipment.insuranceAmount) {
        this.shipment.insuranceAmount = { amount: 0, currencyCode: '' };
      }

      if (!this.shipment.customsAmount) {
        this.shipment.customsAmount = { amount: 0, currencyCode: '' };
      }

      if (this.shipment && this.shipment.receiverPays != null) {
        this.$store.dispatch(
            CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CHANGE_ISRECEIVERPAYS,
            true
        );
      }

      if (this.$route.query.import === 'true') {
        let receiverAddress = editShipment.receiverAddress;
        let pickupAddress = editShipment.pickupAddress;
        this.$refs['userAccount'].setImport();
        this.shipment.shipmentType = "Import"
        this.shipment.receiverAddress = pickupAddress;
        this.shipment.pickupAddress = receiverAddress;
        this.shipment.shipmentOptions.incoterms = null;
      }
    }
    
    //If is Return Shipment from Link Address
    if (this.$route.query.returnShipment !== undefined && this.$route.query.returnShipment === 'true') {
      this.selectedBranch = this.getVisibleUserBranches[0];
      this.$refs['branchSelector-modal'].show();
    }

    //If any action in query set it on the shipment
    if (this.$route.query.action !== undefined) {
      this.shipment.action = this.$route.query.action;
    }

    if (this.display(this.fieldNames.BOOK_EXPORT_PICKUP)) {
      this.viewOptions.showExportPickup = true
    }

    this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
  },
  data() {
    return {
      ready: false,
      viewOptions: {
        showAccount: true,
        showImport: true,
        showCross: true,
        showReceiverAddress: true,
        showSenderAddress: true,
        showPickupAddress: true,
        showShipAt: true,
        showIsDocument: true,
        showCustoms: true,
        showInsurance: true,
        showReceiverPays: true,
        showImportOfRecord: true,
        showExportReason: true,
        showIncoterms: true,
        showDangerousGoods: true,
        showExportPickup:false,
        showOnBehalfOf: false,
      },
      modalTitle: null,
      modalDescription: null,
      newsLoaded: false,
      shipment: {},
      invoiceData: null,
      fieldNames: FIELD_NAMES,
      showInvoice: false,
      files: [],
      shipmentOptionsAdditionalFields: {
        acceptedInsuranceTerms:false
      },
      registerShipment: false,
      selectedBranch: null,
      defaultValues: {}
    };
  },
  computed: {
    ...mapGetters('createShipment', ['getSelectedCompanyId', 'getSelectedCompanyAccount', 'getPrototype', 'isCustomsShipmentAndNotDocument']),
    ...mapGetters('core', ['isSystemInitialized','getVisibleUserBranches']),

    isShipmentSet() {
      return this.$store.state.createShipment.shipment !== {} && this.$v !== null;
    },
    
    validationErrors() {
      return !this.shipmentOptionsAdditionalFields.acceptedInsuranceTerms;
    },

    requireInvoiceOnBook(){
      return !!(this.requireCustoms && this.display(this.fieldNames.REQUIRE_INVOICE)) && !this.registerShipment;
    },
    
    selectedCompanyAccountId() {
      return this.getSelectedCompanyAccount
          ? this.getSelectedCompanyAccount.id
          : null;
    },
    
    showOnBehalfOf() {
      return (
          this.display(this.fieldNames.SHOW_INITIALS_AND_DEPARTMENT)
      );
    },

    showPickup() {
      return (
          !!this.selectedCompanyAccountId &&
          (this.shipment.shipmentType != 'Export' || this.viewOptions.showExportPickup)
      );
    },

    requireCustoms(){
      return this.isCustomsShipmentAndNotDocument(
          this.shipment.shipmentOptions.isDocument,
          this.shipment.pickupAddress,
          this.shipment.receiverAddress,
          this.shipment.shipDate
      )
    },

    listOfAccounts() {
      return this.$store.state.core.companyAccounts;
    },
    ...mapGetters('createShipment', ['getBackendErrors', 'getDefaultValues']),

    getModalTitle: {
      get() {
        if (this.modalTitle == null && this.newsLoaded) {
          return this.$store.state.core.news[0].title;
        }
        return this.modalTitle;
      },
    },

    getModalDescription: {
      get() {
        if (this.modalDescription == null && this.newsLoaded) {
          return this.$store.state.core.news[0].description;
        }
        return this.modalDescription;
      },
    },
  },
  watch: {
    async selectedCompanyAccountId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.shipment.shipFromBookingInitialsOnBehalfOf = null;
        this.shipment.shipFromBookingDepOnBehalfOf = null;
      }
      await this.$store.dispatch(
          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_BOOKING_OPTIONS
      );      
      this.viewOptions.showExportPickup = this.display(this.fieldNames.BOOK_EXPORT_PICKUP)
    }
  },
  methods: {
    async setUploadFiles(files){
      this.files = [];
      let self = this;
      for(let i in files){
        let f = files[i];
        let b64 = await ToBase64String(f)
        self.files.push({
          name: f.name,
          type: 'Invoice',
          base64String: b64
        })
      }
    },

    hideInvoicePage(payload){
      this.showInvoicePage(false);
      this.invoiceData = payload;
    },

    showInvoicePage(show){
      if (this.invoiceData == null)
        this.invoiceData = {};
      this.showInvoice = show;
    },
    
    addResetComponentListener() {
      EventBus.$on('resetShipmentEvent', async () => {
        this.resetCreateShipment();
      });
    },

    setCloneShipment() {
      const storeShipment = this.getPrototype;
      let cloneShipment = helper.cloneObject(storeShipment);
      this.shipment = cloneShipment;

      return cloneShipment;
    },

    async resetCreateShipment() {
      this.setCloneShipment();
      this.showInvoice = false

      this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);

      EventBus.$emit(EVENTS.RESET);
      await this.$store.dispatch(
          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_BACKENDERRORS
      );
      await this.$store.dispatch(
          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_DEFAULT_VALUES
      );
      await this.$store.dispatch(
          CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.FETCH_COMPANY_ACCOUNT_ADDRESSES
      );

      this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
    },

    setDefaultValues(defaultValues) {
      this.defaultValues = defaultValues;
      
      // Texts
      this.shipment.texts.description = defaultValues.defaultDescription;
      this.shipment.texts.sendersReference = defaultValues.defaultSendersReference;
      this.shipment.texts.receiversReference = defaultValues.defaultReceiversReference;

      if (defaultValues.defaultInsuranceValue != null) {
        this.shipment.insuranceAmount.amount = defaultValues.defaultInsuranceValue;
      }

      if (defaultValues.defaultInsuranceCurrency != null) {
        this.shipment.insuranceAmount.currencyCode = defaultValues.defaultInsuranceCurrency;
      }

      if (defaultValues.defaultCustomsValue != null) {
        this.shipment.customsAmount.amount = defaultValues.defaultCustomsValue;
      }
      if (defaultValues.defaultCustomsCurrency != null) {
        this.shipment.customsAmount.currencyCode = defaultValues.defaultCustomsCurrency;
      }

      //Colli
      this.shipment.collis[0].weight = defaultValues.defaultWeight;
      this.shipment.collis[0].length = defaultValues.defaultLength;
      this.shipment.collis[0].height = defaultValues.defaultHeight;
      this.shipment.collis[0].width = defaultValues.defaultWidth;

      //SaveFlags
      this.shipment.saveFlags = {
        saveDescription: false,
        saveReceiverAddress: defaultValues.defaultSaveAddress,
        saveSenderAddress: false,
        savePickupAddress: false,
        saveSoldToAddress: false,
      };
      if (this.shipment.saveFlags.saveReceiverAddress == null)
      {
        this.shipment.saveFlags.saveReceiverAddress = false;
      }

      // Set default recipient type based on DefaultRecipientType
      if (defaultValues.defaultRecipientType != null) {
        const recipientType = defaultValues.defaultRecipientType.trim().toLowerCase();
        if (recipientType === "private") {
          this.shipment.receiverAddress.isPrivate = true;
        } else if (recipientType === "business") {
          this.shipment.receiverAddress.isPrivate = false;
        }
      }
    },
    
    sendToLegacy() {
      window.location.href = 'https://www.linklog.com/';
    },
    
    handleReturnShipment() {
      this.shipment.receiverAddress = helper.cloneObject(this.shipment.senderAddress);
      this.shipment.senderAddress.city = this.selectedBranch.city;
      this.shipment.senderAddress.contactPerson.name = 'Link Logistics';
      this.shipment.senderAddress.contactPerson.phone = this.selectedBranch.phone;
      if (this.selectedBranch.email3) {
        this.shipment.senderAddress.contactPerson.mails = [this.selectedBranch.email3];
      } else {
        this.shipment.senderAddress.contactPerson.mails = [];
      };
      this.shipment.senderAddress.countryCode = this.selectedBranch.countryCode;
      this.shipment.senderAddress.id = null;
      this.shipment.senderAddress.isPrivate = null;
      this.shipment.senderAddress.name = 'Link Logistics ' + this.selectedBranch.name;
      this.shipment.senderAddress.postalCode = this.selectedBranch.zip;
      this.shipment.senderAddress.stateCode = null;
      this.shipment.senderAddress.street1 = this.selectedBranch.address;
      this.shipment.senderAddress.street2 = null;
      this.shipment.senderAddress.street3 = null;
      this.shipment.senderAddress.vatNumber = null;
      this.shipment.texts.sendersReference = 'return: ' + this.shipment.texts.sendersReference;
      this.shipment.pickupAddress = helper.cloneObject(this.shipment.senderAddress);
    },
    
    showModal() {
      if (this.$store.state.core.news.length > 0) {
        this.$refs['info-modal'].show();

        // Set flag that user has seen this, so it wont be shown next time.
        this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_NEWS_SHOWN_FOR_USER);
      }
    },
    
    showUnknownUserModal() {
      this.$refs['unknownUser-modal'].show();
    },

    generateGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;

        return v.toString(16);
      });
    },
  },
};
</script>

<style>
.mb-2 {
  margin-bottom: 10px;
}

#errors {
  text-align: left;
}

#errors ul {
  margin-bottom: 3px;
  list-style-type: none;
  padding-left: 15px;
}

.alert {
  padding: 5px 5px 5px 10px;
  margin-bottom: 5px;
}
</style>
